<template>
  <el-row class="video-container">
    <el-col :span="edit ? 13 : 7" class="list">
      <el-table :data="channelList" style="width: 100%">
        <el-table-column label="序号" type="index" width="80" />
        <el-table-column label="原始通道名称" prop="name" v-if="edit" />
        <el-table-column label="现通道名称" v-if="edit" width="200">
          <template slot-scope="scoped">
            <el-input v-model="scoped.row.currentName" />
          </template>
        </el-table-column>
        <el-table-column label="是否可见" v-if="edit">
          <template slot-scope="scoped">
            <el-switch
              v-model="scoped.row.avaiable"
              active-color="#13ce66"
              inactive-color="#ddd"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="edit" width="80">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click.stop="clickStartRealPlay(scope.row.id)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="查看" v-else width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click.stop="clickStartRealPlay(scope.row.id)"
              >{{ scope.row.currentName }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-col :span="edit ? 10 : 16" :offset="1">
      <div id="divPlugin" class="plugin"></div>
    </el-col>
  </el-row>
</template>

<script>
import webVideoMixin from 'mixin/web-video';
const WebVideoCtrl = window.WebVideoCtrl;
export default {
  props: {
    loginIp: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: false
    },
    channelList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mixins: [webVideoMixin],
  mounted() {
    this.initVideo();
  },
  methods: {
    initVideo() {
      const that = this;
      const iRet = WebVideoCtrl.I_CheckPluginInstall();
      if (iRet === -2) {
        window.alert('您的Chrome浏览器版本过高，不支持NPAPI插件！');
        return;
      } else if (iRet === -1) {
        window.alert(
          '您还未安装过插件，双击开发包目录里的WebComponentsKit.exe安装！'
        );
        return;
      }

      // 初始化插件参数及插入插件
      WebVideoCtrl.I_InitPlugin(that.edit ? 500 : 800, that.edit ? 300 : 600, {
        bWndFull: true, // 是否支持单窗口双击全屏，默认支持 true:支持 false:不支持
        iWndowType: 2,
        cbSelWnd: function(xmlDoc) {}
      });
      WebVideoCtrl.I_InsertOBJECTPlugin('divPlugin');
      WebVideoCtrl.I_ChangeWndNum(1);
      // 检查插件是否最新
      if (WebVideoCtrl.I_CheckPluginVersion() === -1) {
        window.alert(
          '检测到新的插件版本，双击开发包目录里的WebComponentsKit.exe升级！'
        );
      }
    },
    clickStartRealPlay(iChannelID) {
      const that = this;
      const oWndInfo = WebVideoCtrl.I_GetWindowStatus();
      if (oWndInfo !== null) {
        // 已经在播放了，先停止
        WebVideoCtrl.I_Stop();
      }
      WebVideoCtrl.I_StartRealPlay(this.loginIp, {
        iStreamType: that.iStreamType, //
        iChannelID: iChannelID,
        bZeroChannel: false
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.video-container
  overflow hidden
  .list
    height 600px
    overflow auto
    float left
  .plugin
    float right
</style>
